export const mapping = {
  // KeyA: 'RADIO:ui|automenu',
  KeyM: 'RADIO:ui|menu',
  Space: 'BUTTON:spin',
  ArrowLeft: ['BUTTON:prevbet', 'BUTTON:prevauto'],
  ArrowRight: ['BUTTON:nextbet', 'BUTTON:nextauto'],
  // ArrowUp: 'BUTTON:history|prev',
  // ArrowDown: 'BUTTON:history|next',
}
